import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MarketingCollectionDetails } from '../models/marketing-collection-details.model';

import { AppConfig, TOKEN_CONFIG } from '../config/app.config';

@Injectable({ providedIn: 'root' })
export class MarketingService {
  constructor(private http: HttpClient, @Inject(TOKEN_CONFIG) private config: AppConfig) {}

  public getCollectionDetails({
    collectionId,
    areaId,
    dateTime,
    serviceTypes,
  }: {
    collectionId: number;
    areaId?: number;
    dateTime?: string;
    serviceTypes?: number;
  }): Observable<MarketingCollectionDetails> {
    const url = this.config.routes.getMarketingCollectionDetails.url.replace('#collectionId#', collectionId.toString());
    return this.http.get<MarketingCollectionDetails>(url, {
      params: { ...(areaId && { areaId }), ...(dateTime && { dateTime }), ...(serviceTypes && { serviceTypes }) },
    });
  }
}
